import * as React from "react";
import styled from "styled-components";
import Theme from "../Theme";
import { Link } from "react-router-dom";

const Div = styled.div`
  background-color: ${Theme.colors.darkBackground};
  width: 110px;
  height: 65px;
  display: none;

  :hover {
    background-color: ${Theme.colors.darkBackgroundHover};
  }

  & svg {
    transition: fill 0.2s ease-in;
  }

  :hover svg {
    fill: ${Theme.colors.accentWarmLight};
    transition: fill 0.2s ease-in;
  }

  @media all and (min-width: 800px) {
    display: flex;
  }
`;

const StyledLink = styled(Link)`
  display: flex;
  align-items: left;
  justify-content: left;
  padding: 6px 16px;
  cursor: pointer;
  flex-grow: 1;
`;

const Svg = styled.svg`
  width: 84px;
  height: 45px;
  fill: #ffffff;
`;

const LogoBox = () => (
  <Div>
    <StyledLink to="/">
      <Svg preserveAspectRatio="xMidYMid meet">
        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#svg-SSmallLogo"></use>
      </Svg>
    </StyledLink>
  </Div>
);

export default LogoBox;
